import _ from 'lodash';
import io from 'socket.io-client';
import CONFIG from '../../../config';

const IntMax = 2147483647;
const GCTimeOut = 300000;

const openLog = false;
const log = function (msg) {
    if (openLog) {
        console.log(msg);
    }
};

class Socket {
    constructor() {
        this.initializationMessageChannelData();
        const CONNECT_URL = CONFIG.socket.url;
        try {
            this.client = io.connect(CONNECT_URL);
        } catch(e) {
            // do nothing.
        }

        this.listenerVecter();
        this.connectEmitFunc = null;
        this.disconnectEmitFunc = null;
        this.dataEmitFunc = null;
        this.isConnected = false;
        setInterval(() => {
            // log('[垃圾回收]当前hardware/native/channel消息管道数量：', this.channelMessageHandleMap, this.channelMessageTimeHandleMap);
            this.cleanDirtyData();
        }, GCTimeOut);
    }

    /**
     * 初始化消息通道数据
     */
    initializationMessageChannelData() {
        this.messageId = 0;
        this.channelMessageHandleMap = {};
        this.channelMessageTimeHandleMap = {};
    }

    listenerVecter() {
        // callback监听
        this.client.on('s2c_send', (message_id, message) => {
            const channelMessageKey = `${message.connectType}.${message.method}.${message_id}`;
            log("消息[" + channelMessageKey + "] 响应 <=", message);
            if (_.isFunction(this.channelMessageHandleMap[channelMessageKey])) {
                this.channelMessageHandleMap[channelMessageKey](message.error, message.data);
            }
            if (this.channelMessageHandleMap && _.has(this.channelMessageHandleMap, channelMessageKey)) {
                delete this.channelMessageTimeHandleMap[channelMessageKey];
                delete this.channelMessageHandleMap[channelMessageKey];
            }
            // log('当前hardware/native/channel消息管道数量：', this.channelMessageHandleMap, this.channelMessageTimeHandleMap);
        });
        // socket连接监听
        this.client.on('connect', () => {
            this.isConnected = true;
            this.initializationMessageChannelData();
            if (_.isFunction(this.connectEmitFunc)) {
                this.connectEmitFunc('socket.io-client connected.');
            }
            log('s2c=>', 'socket.io-client connect.');
        });
        // socket断开监听
        this.client.on('disconnect', () => {
            this.isConnected = false;
            this.initializationMessageChannelData();
            if (_.isFunction(this.disconnectEmitFunc)) {
                this.disconnectEmitFunc('socket.io-client disconnect.');
            }
            log('s2c=>', 'socket.io-client disconnect.');
        });
        // 数据上报监听
        this.client.on('s2c_receive', (message) => {
            // log('s2c_receive', message);
            if (_.isFunction(this.dataEmitFunc)) {
                this.dataEmitFunc(message);
            }
        });
    }

    cleanDirtyData() {
        for (let i in this.channelMessageTimeHandleMap) {
            let rest = new Date().getTime() - this.channelMessageTimeHandleMap[i];
            if (GCTimeOut <= rest) {
                if (_.isFunction(this.channelMessageHandleMap[i])) {
                    this.channelMessageHandleMap[i]("消息[" + i + "]发送：硬件未响应", {});
                }
                delete this.channelMessageTimeHandleMap[i];
                delete this.channelMessageHandleMap[i];
            }
        }
    }

    getMessageId() {
        this.messageId += 1;
        if (this.messageId >= (IntMax - 1)) {
            this.messageId = 0;
        }
        const rdm = this._getRandomString(8);
        return `${rdm}.${this.messageId}`;
    }

    _getRandomString(len) {
        len = len || 32;
        const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; // 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
        const maxPos = $chars.length;
        let pwd = '';
        for (let i = 0; i < len; i++) {
            pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }

    sendMessage(message, callback) {
        const messageId = this.getMessageId();
        const channelMessageKey = `${message.connectType}.${message.cmd}.${messageId}`;
        this.channelMessageHandleMap[channelMessageKey] = callback;
        this.channelMessageTimeHandleMap[channelMessageKey] = new Date().getTime();
        this.client.emit('c2s_send', messageId, message);
        log("消息[" + channelMessageKey + "] 发送 =>", message);
    }

    addConnectListener(listener) {
        this.connectEmitFunc = listener;
    }

    addDisconnectListener(listener) {
        this.disconnectEmitFunc = listener;
    }

    addDataListener(listener) {
        this.dataEmitFunc = listener;
    }
}

class ChannelDelegate {
    constructor() {
        this.runtime = new Socket();
    }
}

export default new ChannelDelegate();